<template>
        <Button rounded outlined color="primary" v-bind="$attrs" @click="action">
            {{ $t("action.back") }}
        </Button>
</template>

<script>
    import RouterLinkMixin from "@/components/routing/RouterLinkMixin"

    export default {
        mixins: [RouterLinkMixin],

        methods: {
            defaultTo() {
                return -1
            },
        },
    }
</script>

<style lang="scss" scoped></style>
